<template>
    <div class="traffic_page">
        <!--更多操作-->
        <div class="more_option"
             style="display: flex;justify-content: center;align-items: center;font-weight: bold;color: white"
             @click="drawer = true">
            <i class="el-icon-setting" style="font-size: 2rem"></i>
        </div>
        <!--頁面抬頭-->
        <div class="traffic_page_top">
            <div class="traffic_title">
                <div class="back_icon">
                    <div style="display: flex">
                        <i class="icon" @click="goHome()"></i>即時路況
                    </div>
                    <div>
                        <i class="el-icon-location-outline" style="color: white;font-size: 2rem;margin-right: 20px"
                           @click="goNearLocation()"></i>
                        <i class="el-icon-refresh" style="color: white;font-size: 2rem" @click="getTrafficLive()"></i>
                    </div>
                </div>
            </div>
        </div>
        <!--功能列表-->
        <el-drawer title="即時路況設定" size="80%" :visible.sync="drawer" :direction="direction" style="color: #72767b">
            <!--國道選擇-->
            <div style="display: flex; align-items: center;" class="set_block">
                <el-select v-model="freewayId" placeholder="請選擇" @change="changeFreeway"
                           style="margin: 5px;width: 100%">
                    <el-option-group
                        v-for="group in options"
                        :key="group.label"
                        :label="group.label">
                        <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-option-group>
                </el-select>
            </div>
            <!--交流道區間選擇-->
            <div style="display: flex; flex-direction: column" class="set_block">

                <span>顯示路段區間</span>
                <div style="display: flex;">
                    <el-select v-model="fromLocation" placeholder="請選擇" style="margin: 5px"
                               @change="chooseRoadInterval">
                        <el-option
                            v-for="(item,id) in chooseRoadsData"
                            :key="id"
                            :label="item"
                            :value="item"
                            :disabled="id>=toLocationId">
                        </el-option>
                    </el-select>
                    <el-select v-model="toLocation" placeholder="請選擇" style="margin: 5px" @change="chooseRoadInterval">
                        <el-option
                            v-for="(item,id) in chooseRoadsData"
                            :key="id"
                            :label="item"
                            :value="item"
                            :disabled="id<=fromLocationId">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <!--顯示控制-->
            <div class="set_block">
                <span style="color: black">顯示設定</span>
                <div class="speed_show">
                    <el-switch v-model="speed1" active-color="#409EFF" inactive-color="#909399"></el-switch>
                    <div class="speed1 speed_color_block"></div>
                    <span>時速80以上</span>
                </div>
                <div class="speed_show">
                    <el-switch v-model="speed2" active-color="#409EFF" inactive-color="#909399"></el-switch>
                    <div class="speed2 speed_color_block"></div>
                    <span>時速60-80</span>
                </div>
                <div class="speed_show">
                    <el-switch v-model="speed3" active-color="#409EFF" inactive-color="#909399"></el-switch>
                    <div class="speed3 speed_color_block"></div>
                    <span>時速40-60</span>
                </div>
                <div class="speed_show">
                    <el-switch v-model="speed4" active-color="#409EFF" inactive-color="#909399"></el-switch>
                    <div class="speed4 speed_color_block"></div>
                    <span>時速20-40</span>
                </div>
                <div class="speed_show">
                    <el-switch v-model="speed5" active-color="#409EFF" inactive-color="#909399"></el-switch>
                    <div class="speed5 speed_color_block"></div>
                    <span>時速0-20</span>
                </div>
                <div class="speed_show">
                    <el-switch v-model="speed6" active-color="#409EFF" inactive-color="#909399"></el-switch>
                    <div class="speed6 speed_color_block"></div>
                    <span>資料不足</span>
                </div>
                <div class="speed_show">
                    <el-switch v-model="camera" active-color="#409EFF" inactive-color="#909399"></el-switch>
                    <i class="el-icon-video-camera"
                       style="font-size: 2rem;margin-left: 5px;margin-right: 5px;margin-left: 30px;"></i>
                    <span>顯示攝影機</span>
                </div>
                <div class="speed_show">
                    <el-switch v-model="south" active-color="#409EFF" inactive-color="#909399"></el-switch>
                    <i class="el-icon-caret-bottom" style="font-size: 2rem;margin-right: 5px;margin-left: 25px;"></i>
                    <span>南下時速</span>
                </div>
                <div class="speed_show">
                    <el-switch v-model="north" active-color="#409EFF" inactive-color="#909399"></el-switch>
                    <i class="el-icon-caret-top" style="font-size: 2rem;margin-right: 5px;margin-left: 25px;"></i>
                    <span>北上時速</span>
                </div>

            </div>
            <div style="display: flex;justify-content: center;margin-top: 30px">
                <el-button type="info" @click="drawer=false">關閉</el-button>
            </div>

        </el-drawer>
        <!--內頁內容-->
        <div class="page_padding" style="padding-top: 5px;" v-loading="loading" ref="page_padding">
            <!--即時影像顯示視窗-->
            <el-dialog title="即時影像" :visible.sync="dialogVisible" width="90%">
                <div style="display: flex; flex-direction: column;" v-for="(cctv,id) in showCctv" :key="id">
                    <div style="display: flex;justify-content: center"><span
                        style="margin-bottom: 10px;margin-top: 10px;font-size: 1.5rem;">{{cctv.web_title}}</span>
                    </div>
                    <div style="display: flex;justify-content: center">
                        <img :src="imgUrl(cctv.iphone_videourl)" alt=""
                             style="width: 70vw">
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="info" @click="dialogVisible = false">關閉</el-button>
                </span>
            </el-dialog>
            <!--國道名稱-->
            <div class="road_title" v-if="roads.length !=0">
                <span style=" text-align: center">{{options[0].options[freewayId].label}}</span>
            </div>
            <!--交流道資料-->
            <div v-for="(road,id) in roads" :key="id" :ref="road[0].from_location">
                <!--交流道-->
                <el-row :gutter="20">
                    <el-col :span="20" :offset="2">
                        <div class="road_block">
                            <span class="road_block_title" :class="focusLocation(road[0].from_location)"
                            >{{road[0].from_location}}  </span>
                            <p style="margin-top: 5px;font-size: 1rem">{{road[0].display_start_mile}} km</p>
                        </div>
                    </el-col>
                </el-row>
                <!--時速-->
                <el-row :gutter="20" class="speed" align="middle" type="flex" v-if="toLocation!=road[0].from_location">
                    <!--即時影像-->
                    <el-col :span="2" :offset="4" class="camera">
                        <span
                            v-if="camera && checkCamera(road[0].directionid,road[0].display_start_mile,road[0].display_end_mile)"
                            @click="showCamera(road[0].directionid,road[0].display_start_mile,road[0].display_end_mile)">
                            <i class="el-icon-video-camera"></i>
                        </span>
                    </el-col>
                    <!--時速資料-->
                    <el-col :span="8" :offset="2">
                        <el-row>
                            <el-col :span="10" style="min-height: 1px">
                                <!--南下時速-->
                                <div class="road_speed" :class="speedClass(road[0].section_average_speed)"
                                     v-if="speedShow(road[0].section_average_speed) && south" style="height: 100%">
                                    <p><i class="el-icon-caret-bottom" style="font-size:1.4rem"></i></p>
                                    <p class="speed_text">
                                        {{road[0].section_average_speed}}</p>
                                    <p>km/h</p>
                                </div>
                            </el-col>
                            <el-col :span="10" :offset="4" style="min-height: 1px">
                                <!--北上時速-->
                                <div class="road_speed " :class="speedClass(road[1].section_average_speed)"
                                     v-if="speedShow(road[1].section_average_speed) && north">
                                    <p><i class="el-icon-caret-top" style="font-size:1.4rem"></i></p>
                                    <p class="speed_text">
                                        {{road[1].section_average_speed}}</p>
                                    <p>km/h</p>
                                </div>
                            </el-col>
                        </el-row>

                    </el-col>
                    <!--即時影像-->
                    <el-col :span="2" :offset="2" class="camera">
                        <span
                            v-if="camera && checkCamera(road[1].directionid,road[1].display_end_mile,road[1].display_start_mile)"
                            @click="showCamera(road[1].directionid,road[1].display_end_mile,road[1].display_start_mile)">
                            <i class="el-icon-video-camera"></i>
                        </span>
                    </el-col>
                </el-row>
            </div>
            <!--最後的交流道-->
            <el-row :gutter="20" v-if="lastRoad.length!=0 && toLocation==lastRoad[1].from_location">
                <!--            <el-row :gutter="20" v-if="lastRoad.length!=0">-->
                <el-col :span="20" :offset="2">
                    <div class="road_block">
                        <span style="font-size: 1.5rem;font-weight: bold;">{{lastRoad[1].from_location}}</span>
                        <p style="margin-top: 5px;font-size: 1rem">{{lastRoad[1].display_start_mile}} km</p>
                    </div>
                </el-col>
            </el-row>
            <el-empty v-if="lastRoad.length==0" description="暫時沒有資料唷"></el-empty>
            <el-backtop target=".page_padding" :visibility-height="500" :bottom="150"
                        :right="25"/>
        </div>
    </div>
</template>
<script>
    import FN from '@/components/fn'
    import MENU from '@/components/menu.vue'
    import {mapActions} from 'vuex'

    export default {
        components: {},
        mixins: [FN],
        data() {
            return {
                freewayId: 0,
                allLives: [],
                lives: [],
                roads: [],
                roadExtends: [],
                lastRoad: [],
                options: [{
                    label: '',
                    options: [
                        {label: '國道1號', value: 0},
                        {label: '國道1高架', value: 1},
                        {label: '高港高架', value: 2},
                        {label: '國道2號', value: 3},
                        {label: '國道3號', value: 4},
                        {label: '國道3甲', value: 5},
                        {label: '港西連外道路', value: 6},
                        {label: '南港聯絡道', value: 7},
                        {label: '國道4號', value: 8},
                        {label: '國道5號', value: 9},
                        {label: '國道6號', value: 10},
                        {label: '國道8號', value: 11},
                        {label: '國道10號', value: 12},
                        {label: '快速公路62', value: 13},
                        {label: '快速公路64', value: 14},
                        {label: '快速公路66', value: 15},
                        {label: '快速公路68', value: 16},
                        {label: '快速公路72', value: 17},
                        {label: '快速公路74', value: 18},
                        {label: '快速公路76', value: 19},
                        {label: '快速公路78', value: 20},
                        {label: '快速公路82', value: 21},
                        {label: '快速公路84', value: 22},
                        {label: '快速公路86', value: 23},
                        {label: '快速公路88', value: 24},
                    ]
                }],
                drawer: false,
                direction: 'rtl',
                speed1: true,
                speed2: true,
                speed3: true,
                speed4: true,
                speed5: true,
                speed6: true,
                camera: true,
                north: true,
                south: true,
                dialogVisible: false,
                imgRandom: 0,
                cctv: [],
                showCctv: [],
                loading: true,
                latitude: 0,
                longitude: 0,
                roadsLocation: [],
                locationId: '',
                fromLocation: '',
                toLocation: '',
                fromLocationId: 0,
                toLocationId: '',
                chooseRoadsData: [],
            }
        },
        mounted() {
            this.getTrafficLive();
            setInterval(this.reloadImg, 8000);
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            getTrafficLive() {
                this.loading = true;
                this.FETCH({
                    key: 'GET_TRAFFIC_LIVE',
                }).then((res) => {
                    this.handleResponse(res)
                })
            },
            handleResponse(res) {
                var code = res.code;

                if (code == '0') {
                    if (res.data.length > 0) {
                        this.allLives = res.data;
                        this.buildFreewayData();
                        this.chooseRoadInterval();
                    }


                } else if (code > '0') {
                    this.$message.error(res.message);
                } else {
                    this.$message.error('取得路況失敗，請稍後再試。');
                }
                this.loading = false;
            },
            speedClass(speed) {
                speed = parseInt(speed);
                if (speed > 80) {
                    return 'speed1'
                } else if (speed > 60) {
                    return 'speed2'
                } else if (speed > 40) {
                    return 'speed3'
                } else if (speed > 20) {
                    return 'speed4'
                } else {
                    return 'speed6'
                }
            },
            changeFreeway(value) {
                this.freewayId = value;
                this.buildFreewayData();
                this.fromLocation = this.chooseRoadsData[0];
                this.fromLocationId = 0;
                this.toLocation = this.chooseRoadsData[this.chooseRoadsData.length - 1];
                this.toLocationId = this.chooseRoadsData.length - 1;
                this.chooseRoadInterval();
                this.drawer = false;


            },
            speedShow(speed) {
                speed = parseInt(speed);
                if (speed > 80) {
                    return this.speed1
                } else if (speed > 60) {
                    return this.speed2
                } else if (speed > 40) {
                    return this.speed3
                } else if (speed > 20) {
                    return this.speed4
                } else {
                    return this.speed6
                }
            },
            reloadImg() {
                this.imgRandom = this.uniqid();
            },
            imgUrl(url) {
                let splitUrl = new URL(url);
                if(splitUrl.search ==""){
                    return url + '?' + this.imgRandom;
                }else {
                    return url + '&' + this.imgRandom;
                }
            },
            showCamera(directionid, from_milepost, end_milepost) {
                this.showCctv = this.cctv.filter(obj => {
                    return obj.maindirection == directionid && obj.web_mile > from_milepost && obj.web_mile <= end_milepost
                })
                this.dialogVisible = true;

            },
            checkCamera(directionid, from_milepost, end_milepost) {
                var cctv = this.cctv.filter(obj => {
                    return obj.maindirection == directionid && obj.web_mile > from_milepost && obj.web_mile <= end_milepost
                })
                if (cctv.length > 0) {
                    return true;
                }
                return false;
            },
            async goNearLocation() {
                var tmpLocationId = "";
                var tmpDistance = 0;
                await this.getLocation();
                for (var i in this.roadsLocation) {
                    var distance = this.distance(this.latitude, this.longitude, this.roadsLocation[i]['latitude'], this.roadsLocation[i]['longitude'], 'K')
                    // console.log(this.latitude,this.longitude,this.roadsLocation[i]['latitude'],this.roadsLocation[i]['longitude']);
                    if (tmpDistance == 0) {
                        tmpDistance = distance
                        tmpLocationId = this.roadsLocation[i]['id'];
                    } else if (distance < tmpDistance && this.latitude != 0 && this.longitude != 0) {
                        tmpDistance = distance;
                        tmpLocationId = this.roadsLocation[i]['id'];
                    }

                }
                this.locationId = tmpLocationId;

                this.$refs.page_padding.scrollTop = this.$refs[tmpLocationId][0].offsetTop;


            },
            getLocation() {

                // 瀏覽器支援 HTML5 定位方法
                if (navigator.geolocation) {
                    // HTML5 定位抓取
                    navigator.geolocation.getCurrentPosition(function (position) {
                            localStorage.setItem('trafficLatitude', position.coords.latitude)
                            localStorage.setItem('trafficLongitude', position.coords.longitude)
                        },
                        function (error) {
                            switch (error.code) {
                                case error.TIMEOUT:
                                    this.$message('連線逾時');
                                    break;

                                case error.POSITION_UNAVAILABLE:
                                    this.$message('無法取得定位');
                                    break;

                                case error.PERMISSION_DENIED: // 拒絕
                                    this.$message('使用本功能，\n請記得允許手機的GPS定位功能喔!');
                                    break;

                                case error.UNKNOWN_ERROR:
                                    this.$message('不明的錯誤，請稍候再試');
                                    break;
                            }
                        });

                    this.latitude = localStorage.getItem('trafficLatitude');
                    this.longitude = localStorage.getItem('trafficLongitude');
                } else {
                    alert('不支援');
                }
            },
            distance(lat1, lon1, lat2, lon2, unit) {
                if ((lat1 == lat2) && (lon1 == lon2)) {
                    return 0;
                } else {
                    var radlat1 = Math.PI * lat1 / 180;
                    var radlat2 = Math.PI * lat2 / 180;
                    var theta = lon1 - lon2;
                    var radtheta = Math.PI * theta / 180;
                    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                    if (dist > 1) {
                        dist = 1;
                    }
                    dist = Math.acos(dist);
                    dist = dist * 180 / Math.PI;
                    dist = dist * 60 * 1.1515;
                    if (unit == "K") {
                        dist = dist * 1.609344
                    }
                    if (unit == "N") {
                        dist = dist * 0.8684
                    }
                    return dist;
                }
            },
            getRoadsLocation(road) {
                var result = [];

                var id = 0;
                for (var i in road) {
                    var tmpData = [];
                    tmpData['id'] = i;
                    tmpData['longitude'] = road[i][0]['longitude'];
                    tmpData['latitude'] = road[i][0]['latitude']
                    result[id] = tmpData
                    id++;
                }
                return result;
            },
            focusLocation(location) {
                if (this.locationId == location) {
                    return 'active';
                }
                return '';

            },
            chooseRoadInterval() {

                let chooseRoadsData = this.chooseRoadsData; //所有可選的交流道
                let fromLocation = this.fromLocation;   //起點
                let toLocation = this.toLocation;   //終點

                let fromLocationKey = chooseRoadsData.indexOf(fromLocation);    //交流道起點key值
                let toLocationKey = chooseRoadsData.indexOf(toLocation);    //交流道迄點key值
                this.fromLocationId = fromLocationKey;
                this.toLocationId = toLocationKey;

                let chooseData = [];

                for (const key in chooseRoadsData) {
                    if (key >= fromLocationKey && key <= toLocationKey) {
                        chooseData.push(chooseRoadsData[key]);
                    }
                }

                let newRoads = JSON.parse(JSON.stringify(this.allRoads));   //新路段資料
                for (const road in newRoads) {
                    if (chooseData.indexOf(road) == -1) {   //交流道不存在則刪除
                        delete newRoads[road];
                    }
                }

                this.roads = newRoads;


            },
            addChooseRoadData() {
                this.chooseRoadsData = Object.keys(this.roads);
                let lastRoadName = this.lastRoad[0]['end_location'];
                this.chooseRoadsData.push(lastRoadName);
                console.log(this.chooseRoadsData);
            },
            buildFreewayData(){
                this.lives = this.allLives[this.freewayId].live.interchanges;
                this.roads = this.allLives[this.freewayId].live.road;
                console.log('all-',this.allLives)

                this.allRoads = JSON.parse(JSON.stringify(this.roads));
                this.cctv = this.allLives[this.freewayId].live.cctv;
                this.roadExtends = this.allLives[this.freewayId].live.roadExtends;
                this.lastRoad = this.roads[Object.keys(this.roads)[Object.keys(this.roads).length - 1]];
                this.roadsLocation = this.getRoadsLocation(this.roads);
                this.goNearLocation();
                this.addChooseRoadData();
                if (this.fromLocation == '') {
                    this.fromLocation = this.chooseRoadsData[0];
                }
                if (this.toLocation == '') {
                    this.toLocation = this.chooseRoadsData[this.chooseRoadsData.length - 1];
                    this.toLocationId = this.chooseRoadsData.length - 1;
                }

            }


        }
    }
</script>
<style>
    .camera {
        height: 100%;
        font-size: 2rem;
    }

    .road_speed {
        margin-left: 5px;
        margin-right: 5px;
        width: 100%;
        text-align: center;
        /*background: #107626;*/
        color: white;
        padding-bottom: 5px;
    }

    .speed {
        /*display: flex;*/
        /*align-items: center*/
    }

    .el-icon-video-camera {
        color: #0c5460
    }

    .road_block {
        width: 100%;
        text-align: center;
        background: #a9c9c0;
        color: #323334;
        border-radius: 10px;
        padding-top: 5px;
        border: 2px white solid;

    }

    .speed_text {
        font-size: 1.4rem;
        margin-bottom: 5px;
        margin-top: 5px;
    }

    .more_option {
        width: 56px;
        height: 56px;
        background: linear-gradient(to right, #03af4d 0%, #41da1f 100%);
        position: fixed;
        border-radius: 100%;
        right: 1em;
        bottom: 5em;
        z-index: 999;
    }

    .speed_show {
        display: flex;
        margin: 10px;
        align-items: center;
    }

    .speed_color_block {
        height: 20px;
        width: 20px;
        margin: 5px;
        margin-left: 30px;
    }

    .set_block {
        margin: 10px;
    }

    .traffic_title {
        /*display: flex;*/
        color: #fff;
        /*background: linear-gradient(to right, #03af4d 0%, #41da1f 100%);*/
        padding: 1em;
        padding: 10px;
        font-size: 1.2em;
        font-weight: bold;
        /*align-items: center;*/
        width: 100%;

    }

    .traffic_page_top {
        display: flex;
        align-items: center;
        min-height: 70px;
        background: linear-gradient(to right, #03af4d 0%, #41da1f 100%);
    }

    .traffic_title .icon {
        display: block;
        width: 20px;
        height: 20px;
        margin-right: 1em;
        background: url('~@/assets/back_w.svg') no-repeat center;
    }

    .back_icon {
        display: flex;
        justify-content: space-between;
        align-items: center
    }

    .road_title {
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 2rem;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: bold;
        color: rgb(54, 54, 54)
    }

    .road_block_title {
        font-size: 1.5rem;
        font-weight: bold;
    }

    .road_block_title.active {
        color: #000000;
        font-size: 1.8rem;
    }
</style>




